import {TextSmallRegular} from '@hm/fundamental'
import {useEffect, useRef} from 'react'

import {Canvas2D} from '../canvas/Canvas2D'

import {drawXAxisWithLabels} from './drawXAxisWithLabels'

type GanttChartXAxisProps = {
  canvasWidth: number
  kilnLength: number
  stepWidth: number
  xAxisLabelHeight?: number
  yAxisLabelWidth: number
  xAxisLabel?: string
  'data-test-id'?: string
}

const DEFAULT_X_AXIS_LABEL_HEIGHT = 20

export const GanttChartXAxis = ({
  canvasWidth,
  kilnLength,
  stepWidth,
  xAxisLabelHeight,
  yAxisLabelWidth,
  xAxisLabel,
  'data-test-id': dataTestId
}: GanttChartXAxisProps) => {
  const xLabelCanvasRef = useRef<HTMLCanvasElement>(null)

  const labelHeight = xAxisLabelHeight ?? DEFAULT_X_AXIS_LABEL_HEIGHT

  useEffect(() => {
    const ctx = xLabelCanvasRef.current?.getContext('2d')
    if (!ctx || !xLabelCanvasRef.current) return
    ctx.clearRect(0, 0, xLabelCanvasRef.current.width, xLabelCanvasRef.current.height)

    drawXAxisWithLabels({
      ctx,
      canvasWidth: canvasWidth,
      xMax: kilnLength,
      interval: Number((canvasWidth / (15 * stepWidth)).toFixed())
    })
  }, [canvasWidth, kilnLength, stepWidth])

  return (
    <div className={`w-full h-[${labelHeight}px] flex`} data-test-id={dataTestId}>
      <div style={{width: `${yAxisLabelWidth}px`}} className="h-full">
        <TextSmallRegular className={'text-foreground_faded'}>{xAxisLabel}</TextSmallRegular>
      </div>
      <Canvas2D width={canvasWidth} height={labelHeight} ref={xLabelCanvasRef} />
    </div>
  )
}
